export const toEnglishDate = (date) => {
  const array = date.split("/");
  const day = array[0]?.length === 1 ? `0${array[0]}` : array[0];
  const month = array[1]?.length === 1 ? `0${array[1]}` : array[1];
  return `${array[2]}-${month}-${day}`;
};

export const toSpanishDate = (date) => {
  try {
    const array = date.split("-");
    return `${array[2]}/${array[1]}/${array[0]}`;
  } catch (error) {
    return false;
  }
};

export const millisToDays = (milliseconds) => {
  const millisecondsInOneDay = 1000 * 60 * 60 * 24;
  const days = Math.floor(milliseconds / millisecondsInOneDay);
  return days;
};
